import React, { useRef } from 'react';
import { Icon } from './';

export function Checkbox({
  value,
  onChange,
  custom,
  onIcon,
  offIcon,
  disabled,
  ...moreProps
}) {
  // console.log('Value is', value);
  const inputRef = useRef();
  const isChecked =
    value !== undefined && (value === true || value === 'checked');
  const classes = ['chronos-form-checkbox'];
  if (custom) {
    classes.push('chronos-custom-checkbox');
  }
  if (isChecked) {
    classes.push('chronos-checkbox-checked');
  }
  if (disabled) {
    classes.push('disabled');
  }
  const handleChange = (ev) => {
    // console.log('Simple change');
    if (disabled) return;
    if (onChange) {
      const { checked } = ev.target;
      onChange(checked);
    }
  };

  const handleCustomChange = (ev) => {
    // console.log('Custom Change', !isChecked);
    if (disabled) return;
    if (onChange) {
      ev.preventDefault();
      const { checked } = inputRef.current;
      // console.log("Ref'd value", checked);
      onChange(!checked);
    }
  };
  return (
    <div className={classes.join(' ')} {...moreProps}>
      <input
        type="checkbox"
        className="chronos-checkbox"
        checked={value}
        onChange={handleChange}
        ref={inputRef}
        disabled={disabled ? true : false}
      />

      {custom && (
        <div
          className="chronos-custom-checkbox-control"
          onClick={handleCustomChange}
        >
          {isChecked && (
            <React.Fragment>
              {onIcon && <Icon icon={onIcon} />}
              {!onIcon && <Icon icon="far fa-check fa-fw" />}
            </React.Fragment>
          )}
          {!isChecked && (
            <React.Fragment>
              {offIcon && <Icon icon={offIcon} />}
              {!offIcon && <Icon icon="far" />}
            </React.Fragment>
          )}
        </div>
      )}
    </div>
  );
}
